@if (displayAlert) {
  <div class="alert d-flex align-items-center" [ngClass]="className" role="alert">
    @if (type === AlertType.SUCCESS) {
      <fa-icon [icon]="faCircleCheck" class="flex-shrink-0 me-2"></fa-icon>
    }
    @if (type === AlertType.ERROR || type === AlertType.WARNING) {
      <fa-icon [icon]="faTriangleExclamation" class="flex-shrink-0 me-2"></fa-icon>
    }
    @if (type === AlertType.INFO) {
      <fa-icon [icon]="faCircleInfo" class="flex-shrink-0 me-2"></fa-icon>
    }
    <span class="flex-grow-1" [innerHTML]="message"></span>
    @if (dismissButton) {
      <button type="button" class="btn-close" (click)="removeAlert()" aria-label="Close"></button>
    }
  </div>
}

